import React from 'react';
import { useAuth } from '../context/AuthContext';

const AuthDebug = () => {
  const { user, token, loading, isAuthenticated } = useAuth();

  const handleSetTestAuth = () => {
    // Set REAL authentication data from working backend
    const testUser = {
      id: "8f76bb01-0a9c-4f8e-8c6f-0bb1241eb9b8",
      email: "admin@theequalizer.ai",
      full_name: "System Administrator",
      role: "admin",
      is_active: true,
      is_verified: true,
      profile_data: {},
      subscription_tier: "free",
      created_at: "2025-09-24T18:29:26.212000"
    };
    
    const testToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI4Zjc2YmIwMS0wYTljLTRmOGUtOGM2Zi0wYmIxMjQxZWI5YjgiLCJleHAiOjE3NjIwNDE0OTl9.Ouqg4Rdlrw5xYxnsz7dv_oRwwokDQj4JvrEveBvXo8U";
    
    localStorage.setItem('auth_token', testToken);
    localStorage.setItem('user_data', JSON.stringify(testUser));
    
    console.log('Real auth data set, reloading page...');
    window.location.reload();
  };

  const handleClearAuth = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    console.log('Auth data cleared, reloading page...');
    window.location.reload();
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Authentication Debug Page</h1>
      
      <div style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc', backgroundColor: '#f5f5f5' }}>
        <h3>AuthContext State:</h3>
        <p><strong>Loading:</strong> {loading ? 'true' : 'false'}</p>
        <p><strong>Is Authenticated:</strong> {isAuthenticated ? 'true' : 'false'}</p>
        <p><strong>Has User:</strong> {user ? 'true' : 'false'}</p>
        <p><strong>Has Token:</strong> {token ? 'true' : 'false'}</p>
        {user && (
          <div>
            <p><strong>User ID:</strong> {user.id}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Full Name:</strong> {user.full_name}</p>
          </div>
        )}
        {token && (
          <p><strong>Token (first 50 chars):</strong> {token.substring(0, 50)}...</p>
        )}
      </div>
      
      <div style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc', backgroundColor: '#f0f8ff' }}>
        <h3>LocalStorage Values:</h3>
        <p><strong>auth_token:</strong> {localStorage.getItem('auth_token') ? 'exists' : 'null'}</p>
        <p><strong>user_data:</strong> {localStorage.getItem('user_data') ? 'exists' : 'null'}</p>
        
        {localStorage.getItem('auth_token') && (
          <p><strong>Token (first 50):</strong> {localStorage.getItem('auth_token').substring(0, 50)}...</p>
        )}
        
        {localStorage.getItem('user_data') && (
          <div>
            <p><strong>User Data:</strong></p>
            <pre style={{ fontSize: '12px', backgroundColor: '#fff', padding: '5px' }}>
              {localStorage.getItem('user_data')}
            </pre>
          </div>
        )}
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <button onClick={handleSetTestAuth} style={{ padding: '10px 20px', marginRight: '10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}>
          Set Test Auth Data
        </button>
        
        <button onClick={handleClearAuth} style={{ padding: '10px 20px', backgroundColor: '#f44336', color: 'white', border: 'none', cursor: 'pointer' }}>
          Clear Auth Data
        </button>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h3>Actions:</h3>
        <p>
          <a href="/profile/edit" style={{ color: 'blue', textDecoration: 'underline' }}>
            Test Profile Edit Access
          </a>
        </p>
      </div>
    </div>
  );
};

export default AuthDebug;